import { InjectionToken, Injector } from "@angular/core";

const BASE_URL_TOKEN = new InjectionToken<string>("BaseUrl");
const injector = Injector.create({
    providers: [{ provide: BASE_URL_TOKEN, useValue: "#{Env:baseUrl}" }]
});

export const BASE_URL = injector.get(BASE_URL_TOKEN);
